export * from './use-add-static-product';
